<template>
  <section class="tcs-promo">
    <div class="tcs-promo__content">
      <h1 class="tcs-promo__title">Train, Certify & Save</h1>
      <div class="tcs-promo__intro-wrapper">
        <div class="tcs-promo__description">
          Pick the perfect training promotion to match with your upskilling needs - for individual
          learners!
        </div>
        <div class="tcs-promo__intro">Shop savings below</div>
      </div>
    </div>
    <div class="tcs-promo__icon">
      <div class="tcs-promo__icon-logo-wrapper">
        <img :src="TCSLogoImg" alt="Train, Certify, & Save" class="tcs-promo__icon-logo" />
      </div>
    </div>
  </section>
</template>

<script>
import TCSLogoPng from '@/assets/images/hero-section/tcs-promo/tcs-promo.png'
import { routesRules } from '@/helpers/mixins'

export default {
  name: 'TCSPromoHeroSection',
  mixins: [routesRules],
  data() {
    return {
      TCSLogoImg: TCSLogoPng,
    }
  },
}
</script>

<style lang="scss" scoped>
.tcs-promo {
  width: 100%;
  max-width: 1120px;
  color: var(--white);
  @include font-book;
  display: flex;
  flex-flow: column-reverse;
  position: relative;
  padding: 0 20px 20px 20px;
  @include mobile {
    flex-flow: row;
  }
  @include desktop {
    flex-flow: row;
    margin: auto;
    padding: 50px 0 100px 0;
  }
  &__title {
    color: var(--white);
    @include font-medium;
    font-size: rem(35px);
    font-style: normal;
    font-weight: 900;
    line-height: rem(37px);
    margin: 0;
    @include mobile {
      font-size: rem(40px);
    }
    @include desktop {
      font-size: rem(54px);
      line-height: rem(50px);
    }
  }
  &__intro {
    font-size: rem(17px);
    font-style: normal;
    font-weight: 700;
    line-height: rem(26px);
    margin-top: 24px;
    @include desktop {
      font-size: rem(24px);
      line-height: rem(32px);
    }
  }
  &__description {
    color: var(--light-blue-gray);
    font-size: rem(17px);
    font-style: normal;
    font-weight: 450;
    line-height: rem(26px);
    width: 100%;
    @include mobile {
      width: 90%;
    }
    @include desktop {
      width: 85%;
      font-size: rem(24px);
      line-height: rem(32px);
    }
  }
  &__content {
    display: flex;
    flex-flow: column;
    gap: 20px;
    @include mobile {
      margin-top: 70px;
    }
    &--mt-10 {
    }
  }
  &__icon {
    position: relative;
    top: -40px;
    &-logo {
      width: 100%;
    }
    &-logo-wrapper {
      margin: 30px auto;
      display: flex;
      justify-content: center;
      @include mobile {
        width: 300px;
        height: unset;
      }
      @include desktop {
        width: 515px;
        height: 440px;
      }
    }
  }
}
</style>
